import { LOCATION_CHANGE } from 'connected-react-router';
import ActionTypes from '../constants/ActionTypes';

const initialState = {
  menuActived: false,
  menuDesktopActived: true,
  themeMode: localStorage.getItem('theme'),
};

export default (state = initialState, { type }) => {
  switch (type) {
    case LOCATION_CHANGE:
      return {
        ...state,
        menuActived: false,
      };
    case ActionTypes.TOGGLE_MENU:
      return {
        ...state,
        menuActived: state.menuActived === undefined || state.menuActived === false,
      };
    case ActionTypes.TOGGLE_MENU_DESKTOP:
      return {
        ...state,
        menuDesktopActived:
          state.menuDesktopActived === undefined || state.menuDesktopActived === false,
      };
    case ActionTypes.TOGGLE_MODE: {
      let mode = 'light';
      if (state.themeMode === 'light') mode = 'dark';
      return {
        ...state,
        themeMode: mode,
      };
    }
    default:
      return state;
  }
};
